module.exports = __webpack_public_path__ + "media/img/pages/companies/zuehlke-8f6297aadb260b0a446e4d9d7f13cbdb.png";